import Util from './Util.js'
import FieldFactory from './FieldFactory.js'

const functionField = /^(?<func>[a-zA-Z-_][a-zA-Z0-9.-_]*)\((?<args>[a-zA-Z0-9, ._()*/+\-:']*)\)$/d

export default {
  id : 'Expression.FieldParser.FunctionField',
  type : 'functionField',
  sort : 3,
  handles : ( field, context ) => {
    if ( field.type !== 'ExpressionParser.Field' ) {
      return false
    }
    const hasAlias = Util.handleAlias( field.value, { context } )
    if ( hasAlias ) {
      return hasAlias.field?.match( functionField )
    }
    return field.value?.match( functionField )
  },
  parse : async ( field, context ) => {
    const hasAlias = Util.handleAlias(
      field.value,
      { context : { ...context, field } }
    )
    let value = field.value, alias
    if ( hasAlias ) {
      value = hasAlias.field
      alias = hasAlias.alias
    }

    const match = value.match( functionField )
    const func = match.groups.func
    const args = await FieldFactory.create(
      match.groups.args,
      {
        ...context,
        field : { ...field, type : 'ExpressionField.function', func },
        indexOffset : match.indices.groups.args[0]
      }
    )

    const toReturn = {
      type : 'ExpressionField.function',
      func,
      args : args.fields,
    }
    if ( hasAlias ) {
      toReturn.alias = alias
    }
    if ( context?.includeAstInfo ) {
      toReturn.absoluteLocation = {
        startIndex : field.startIndex,
        endIndex : field.startIndex +
          ( hasAlias ? hasAlias.field.length : field.value.length ),
      }
      toReturn.relativeLocation = {
        startIndex : 0,
        endIndex : hasAlias ? hasAlias.field.length : field.value.length
      }
      toReturn.commaLocations = args.commaLocations
      toReturn.untrimmed = field.untrimmed
      if ( hasAlias ) {
        toReturn.aliasLocation = {
          absolute : hasAlias.absoluteLocation,
          relative : hasAlias.relativeLocation,
        }
      }
    }
    return toReturn
  }
}
